import { render, staticRenderFns } from "./AlertModal.vue?vue&type=template&id=49d81e0f"
import script from "./AlertModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AlertModal.vue?vue&type=style&index=0&id=49d81e0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports